import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Header from "../common/header";
import Sidebar from "../common/sidebar";
import Breadcrumb from "../common/menuGuide";
import alertUtils from "../../utils/utils";

function NoticeDetailPage() {
    const navigate = useNavigate();
    const currentPath = window.location.pathname;

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [detail, setDetail] = useState(null);

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    const handleBreadcrumbClick = (item, index) => {
        if (index === 0) {
            setSidebarOpen(true);
        }
    };

    useEffect(() => {
        const savedData = sessionStorage.getItem("noticeDetailData");

        if (!savedData) {
            alertUtils.warning("상세 데이터가 없습니다.");
            navigate("/notice", { replace: true });
            return;
        }

        try {
            const parsed = JSON.parse(savedData);
            setDetail(parsed);
        } catch (error) {
            console.error("상세 데이터 파싱 실패:", error);
            alertUtils.error("상세 데이터를 불러오지 못했습니다.");
            navigate("/notice", { replace: true });
        }
    }, [navigate]);

    const backToList = () => {
        navigate("/notice", { state: { restore: true } });
    };

    if (!detail) return null;

    return (
        <div className="container">
            <Header
                isSidebarOpen={sidebarOpen}
                onMenuToggle={() => setSidebarOpen((prev) => !prev)}
            />

            {sidebarOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            <Sidebar
                isOpen={sidebarOpen}
                onClose={closeSidebar}
                currentPath={currentPath}
            />

            <main className="content">
                <Breadcrumb items={["상담 관리", "공지사항관리", "공지사항 상세"]}
                            onItemClick={(item, index) => {
                                if (index === 0) {
                                    handleBreadcrumbClick(item, index)
                                }

                                if (index === 1) {
                                    navigate("/notice");
                                }
                            }}
                />

                <section className="page">
                    <div className="title-container">
                        <h1>공지사항 상세</h1>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={backToList}
                        >
                            목록
                        </button>
                    </div>

                    <table className="detail-table">
                        <tbody>
                        <tr>
                            <th>날짜</th>
                            <td>{detail?.registDate}</td>
                        </tr>

                        <tr>
                            <th>등록자</th>
                            <td>{detail?.userName}</td>
                        </tr>

                        <tr>
                            <th>판매정보</th>
                            <td>
                                <div className="text-box" style={{whiteSpace: "pre-line"}}>{detail?.salesInfo}</div>
                            </td>
                        </tr>

                        <tr>
                            <th>수리 및 기타 정보</th>
                            <td>
                                <div className="text-box" style={{whiteSpace: "pre-line"}}>{detail?.repairInfo}</div>
                            </td>
                        </tr>

                        <tr>
                            <th>상담센터 기재 공지사항</th>
                            <td>
                                <div className="text-box" style={{whiteSpace: "pre-line"}}>{detail?.etcInfo}</div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </section>
            </main>
        </div>
    );
}

export default NoticeDetailPage;